export enum SmartviewCategory {
  ALL,
  VISIBLE,
  PERSONAL,
  ORGANIZATION
}
